import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';
import { ARRAY_ERROR } from 'final-form';

import { Button } from 'UIPackage/MainModule/components/Button';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';

import { KnmAttachmentsSigning } from '../MainModule/components/KnmAttachmentsSigning';

interface IKnmJudgmentDocumentProps {
  className?: string;
  disableToAdd: boolean;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  name: string;
  watchOnly: boolean;
}

export const KnmJudgmentDocument = memo(
  ({ className = '', disableToAdd, formRef, name, watchOnly }: IKnmJudgmentDocumentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={className}>
        <div className="shared-group-label">
          Файл&nbsp;
          <span className="shared-no-wrap-text">
            решения
            <Button
              className="shared-btn-add"
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={watchOnly || disableToAdd}
              onClick={openSignModal}
            />
          </span>
        </div>
        <FormSpy subscription={{ errors: true, touched: true }}>
          {props => {
            const reasonsFieldError = props.errors?.judgments?.find(
              (item: { attachment: { [x: string]: string } }, index: number) =>
                Number(name.split('').find(char => Number.isFinite(Number(char)))) === index &&
                item?.attachment?.[ARRAY_ERROR],
            );

            if (reasonsFieldError) {
              return <p className="shared-input-error">Поле не может быть пустым</p>;
            }

            return null;
          }}
        </FormSpy>
        <KnmAttachmentsSigning
          isWatchOnly={watchOnly}
          name={name}
          isRequired={true}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          acceptedFiles=".pdf,.png,.jpeg,.ktd,.rtf,.rar,.zip"
          formRef={formRef}
        />
      </div>
    );
  },
);
